import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=74142923&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=ts&"
export * from "./Switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74142923",
  null
  
)

export default component.exports